import type { MessageType } from "@expert/shared-types";

import { Flex } from "@mantine/core";
import { useMergedRef } from "@mantine/hooks";

import type { BubbleStyle } from "../../config/types";

import classes from "./MessageBubble.module.css";

const bubbleStyleClassMap: Record<BubbleStyle, string> = {
    reactive: classes.reactiveBubble,
    proactive: classes.proactiveBubble,
    aiGenerated: classes.aiGeneratedBubble,
    expert: classes.expertBubble,
    smartOffer: classes.smartOfferBubble,
    smartOfferGeneric: classes.smartOfferGenericBubble,
    smartOfferResponse: classes.smartOfferResponseBubble,
};

interface MessageBubbleSimplifiedProps {
    type: MessageType;
    bubbleStyle: BubbleStyle;
    dataVariant: "proactive" | "reactive";
    hasHeader: boolean;
    overflowRef: React.RefObject<HTMLDivElement | null>;
    messageIntersectionRef: (node: HTMLDivElement | null) => void;
    children: React.ReactNode;
}

export function MessageBubbleSimplified({
    type,
    bubbleStyle,
    dataVariant,
    hasHeader,
    overflowRef,
    messageIntersectionRef,
    children,
}: MessageBubbleSimplifiedProps) {
    const mergedRef = useMergedRef(overflowRef, messageIntersectionRef);
    const bubbleClass = bubbleStyleClassMap[bubbleStyle];
    const headerRadiusClass = hasHeader ? classes.bubbleWithHeader : "";

    return (
        <Flex
            className={
                type === "SessionSummary"
                    ? `fs-mask ${classes.bubble} ${bubbleClass} ${headerRadiusClass}`.trim()
                    : `${classes.bubble} ${bubbleClass} ${headerRadiusClass}`.trim()
            }
            data-testid={`message-bubble-${type}`}
            ref={mergedRef}
            direction="column"
            data-variant={dataVariant}
        >
            {children}
        </Flex>
    );
}
